import type { RnPaymentHistoryItem } from "./api";

/**
 * React key for one row of the Payments history.
 *
 * Not the visit id alone: a visit can have two rows, its pay and a later pay
 * difference (a top-up after its pay went up, e.g. it was marked missed and
 * then found to have happened), usually in different batches. Two rows with the
 * same key make React drop or duplicate one of them on re-render.
 */
export function paymentRowKey(
    item: Pick<RnPaymentHistoryItem, "visitId" | "batchId" | "paymentStatus" | "payDifference">
): string {
    return [
        item.visitId,
        item.batchId ?? item.paymentStatus,
        item.payDifference === true ? "diff" : "pay"
    ].join("-");
}
